export default __webpack_public_path__ + "static/mugen-art-d764f8a54c41bc77947faf1ce748c77c.png";